import React, { Component } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { getSlotDescription, Meta } from '../../common'
import './LemurOrderRestrHelp.css'


export interface LemurOrderRestrHelpProps extends WithTranslation {
    meta: Meta,
    formik: any
}

class LemurOrderRestrHelp extends Component<LemurOrderRestrHelpProps> {


    makeMustFollowPattern(values: any) {
        let pattern: string[] = []
        if (!values.feats[':form:mwe:franta:mustfollow'])
            return ''
        const slots = values.slots.filter(s => !s.type.startsWith(':phrase'))
        let nestedGroups: string[][] = []
        if (values.feats[':form:comps']) {
            for (let s of slots) {
                if (s.type === ':var') {
                    for (let fl of s.fillers) {
                        const flid = s._id+'/'+fl._id
                        if (!values.feats[':form:comps'][flid])
                            continue
                        for (let f of values.feats[':form:comps'][flid]) {
                            const refs = f.value
                            if (refs) nestedGroups.push(refs)
                        }
                    }
                }
            }
        }

        const nested: string[] = nestedGroups.reduce((acc, group) => acc.concat(group), [])
        const remaining = slots.filter(s => !nested.includes(s.name)).map((s: any) => s.name)
        const groups: string[][] = [remaining, ...nestedGroups]
        
        let deps: string[] = []
        for (let group of groups) {
            let dep: string[] = []
            let last = ''
            for (let i in group) {
                if (values.feats[':form:mwe:franta:mustfollow'][group[i]]) {
                    if (!dep.length) {
                        if (!last) dep.push('?')
                        else dep.push(last)
                    }
                    dep.push(group[i])
                } else if (dep.length) {
                    deps.push(dep.join(' < '))
                    dep = []
                }
                last = group[i]
            }
            if (dep.length)
                deps.push(dep.join(' < '))
            if (deps.length)
                pattern.push(deps.join('; '))
            deps = []
        }
        return pattern.join('; ')
    }

    render() {
        const { formik, meta, t } = this.props
        const slots = formik.values.slots

        const mfpattern = this.makeMustFollowPattern(formik.values)
    
        return(
            <div className="lemur_order_restr_help">
                { mfpattern ? <p><strong>{t('Omezení podle příznaků \'bezpr. následuje\':')}</strong> {mfpattern}</p> : null }
                <p>
                    <strong>{t("Slots")}:</strong> 
                { slots.map(s => 
                    <span className="slot" style={{backgroundColor: meta.cats['slot'][s.type].params?.color || 'transparent'}}>
                        [{s.name}] {getSlotDescription(s, meta, formik.values).join('/')}
                    </span>)
                }
                </p>
                <div className="operators">
                    <div className="column">
                        <ul>
                            <li><code>{"a < b"}</code> – <code>b</code> následuje bezprostředně po <code>a</code></li>
                            <li><code>{"a << b"}</code> – <code>b</code> následuje po <code>a</code>, mezi nimi není jiný slot</li>
                            <li><code>{"a <<< b"}</code> – <code>b</code> následuje po <code>a</code> (bez omezení)</li>
                            <li><code>{"[< a, b, c]"}</code> – libovolná permutace <code>a</code>, <code>b</code>, a <code>c</code>, následují bezprostředně po sobě</li>
                            <li><code>{"[<< a, b, c]"}</code> – libovolná permutace <code>a</code>, <code>b</code> a <code>c</code>, následují po sobě a mezi nimi není jiný slot</li>
                            <li><code>{"^a"}</code> –  slot <code>a</code> stojí na začátku MWE</li>
                            <li><code>{"$a"}</code> –  slot <code>a</code> stojí na konci MWE</li>
                            <li><code>{"!^a"}</code> –  slot <code>a</code> nestojí na začátku MWE</li>
                            <li><code>{"!$a"}</code> –  slot <code>a</code> nestojí na konci MWE</li>
                            <li><code>{"^^"}</code> –  MWE stojí na začátku klauze</li>
                            <li><code>{"$$"}</code> –  MWE stojí na konci klauze</li>
                        </ul>
                    </div>
                    <div className="column">
                        <ul>
                            <li><code>@a</code> – kontextový slot <code>a</code>, není součástí MWE</li>
                            <li><code>#a</code> – kontextový neg. slot <code>a</code> se nesmí vyskytnout na dané pozici, např. <code>{"x << #a"}</code></li>
                            <li><code>%a</code> – negativní slot <code>a</code>, nesmí se vůbec vyskytnout ve stejné klauzi jako MWE</li>
                            <li><code>1:%a</code> – negativní slot <code>a</code> se nesmí vyskytnout v rámci první klauze (pokud MWE přesahuje hranice klauzí)</li>
                            <li><code>{"&&"}</code> – logické 'a', např. <code>{"a < b && d < e"}</code></li>
                            <li><code>{"||"}</code> – logické 'nebo', např. <code>{"a < b || b < a"}</code></li>
                            <li>závorky <code>(</code> a <code>)</code>, např. <code>{"a < b && (c < d || e < f)"}</code></li>
                            <li><code>;</code> – oddělení nesouvisejících pravidel na nejvyšší úrovni, např. <code>{"^^; ^a; d < e || e < d"}</code></li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

}

export default withTranslation()(LemurOrderRestrHelp)